import { DataRoomAccessPermission } from './data-room.enums';

/**
 * Off since the viewer landed: a recipient's stored grant decides again what they may do, and the
 * controls that set it are live. Left in place for one QA round — the flag is the whole revert.
 *
 * Temporary: every recipient of every room has View + Download, and the controls that would
 * change it are disabled.
 *
 * Stored permissions are deliberately left as they are. The lock is applied when a permission is
 * read, never when one is written, so whatever an Admin chose before survives underneath and
 * comes back the moment this is switched off — no migration on the way in, none on the way out.
 *
 * It is applied at the read boundary only — the services below it, and `canDownloadSpaceFile`
 * itself, keep the real rule and are still tested on it, so nothing has to be unpicked there when
 * it is lifted.
 *
 * To lift it: set this to `false`. To remove it for good: delete this file, the two
 * `effectiveDataRoomPermission` calls in each read service, and the two front-end controls'
 * references to the flag.
 */
export const DATA_ROOM_PERMISSION_LOCKED: boolean = false;

/** What every recipient is treated as having while the lock is on. */
export const DATA_ROOM_LOCKED_PERMISSION = DataRoomAccessPermission.VIEWER_DOWNLOAD;

/**
 * The permission to act on and to show, which is the stored one once the lock is lifted. Every
 * read of a permission goes through here so the table, the menu and the server's own refusal
 * cannot drift apart while it is on.
 */
export const effectiveDataRoomPermission = (
  permission: DataRoomAccessPermission,
): DataRoomAccessPermission =>
  DATA_ROOM_PERMISSION_LOCKED ? DATA_ROOM_LOCKED_PERMISSION : permission;
